import { PlantationRisk } from 'src/app/models/traceability-state.model';

// TCL should be on the top of the list
// This list supports old risk types - selfOverlap, self_overlap_v1, tree_cover_loss_eudrv1
// Labels below mirror the CRD system-risks catalogue (type == overlap) and are
// used as a fallback when the catalogue isn't consulted or doesn't return a match. Survey-type risks are intentionally excluded as they are not relevant to the shipment table for now.
// Field names mirror the catalogue's PlantationRisk shape so entries are a subset of it.
const RISK_TYPES_LIST: Pick<PlantationRisk, 'name' | 'display_name'>[] = [
  {
    name: 'tree_cover_loss_eudrv1',
    display_name: 'Tree Cover Loss Post 2020'
  },
  {
    name: 'tree_cover_loss_v1',
    display_name: 'Hansen Tree Cover Loss'
  },
  {
    name: 'tree_cover_loss_canopy_v1',
    display_name: 'Hansen Tree Cover Loss'
  },
  {
    name: 'wdpa_v1',
    display_name: 'Protected Forests'
  },
  {
    name: 'thailandforest_v1',
    display_name: 'Thailand Forests 2020'
  },
  {
    name: 'thaiprotectedareas_v1',
    display_name: 'Thailand Protected Areas'
  },
  {
    name: 'thaireservedforests_v1',
    display_name: 'Thailand Reserved Forests'
  },
  {
    name: 'indonesiaforest_v1',
    display_name: 'Indonesia Forests'
  },
  {
    name: 'klhk_v1',
    display_name: 'KLHK'
  },
  {
    name: 'sbtn_v202011',
    display_name: 'SBTN Natural Lands 2020'
  },
  {
    name: 'eujrcgfc2020_v2',
    display_name: 'Forest Presence in 2020'
  },
  {
    name: 'agdprotectedarea2025_v1',
    display_name: 'Protected Area'
  },
  {
    name: 'agdrestrictedusearea2025_v1',
    display_name: 'Restricted Use Area'
  },
  {
    name: 'waterbodies_v1',
    display_name: 'Waterbodies'
  },
  {
    name: 'buildings_v1',
    display_name: 'Built Area'
  },
  // FE overrides:
  // - `selfOverlap` is a legacy key not present in the catalogue, kept for old data.
  {
    name: 'selfOverlap',
    display_name: 'Plantation Overlap'
  },
  {
    name: 'self_overlap_v1',
    display_name: 'Plantation Overlaps'
  },
  {
    name: 'agddeforestation2025_v1',
    display_name: 'Deforestation'
  }
];

// New types will have risk_ prefix so we will support both old and new types
export const getRiskTypeList = () => {
  const risks = RISK_TYPES_LIST;
  const withRiskPrefix = risks.map((risk) => ({
    ...risk,
    name: `risk_${risk.name}`
  }));

  return [...risks, ...withRiskPrefix];
};

const RISK_LABEL_BY_KEY = new Map(
  getRiskTypeList().map((risk) => [risk.name, risk.display_name])
);

// Maps a backend risk key (e.g. 'risk_agddeforestation2025_v1') to its
// human-readable label. Falls back to the raw key if we have no label for it, such as legacy (non risk_-prefixed) keys absent from the CRD system-risks catalogue.
export const getRiskLabel = (key: string): string =>
  RISK_LABEL_BY_KEY.get(key) ?? key;
